<template>
  <md-toolbar
    id="toolbar"
    :class="{
      [`md-${type}`]: !navbarTransparent,
      [extraNavClasses]: navbarTransparent,
      'md-transparent': navbarTransparent,
      'md-fixed': isNavbarFixed
    }"
    :color-on-scroll="colorOnScroll"
  >
    <div class="md-toolbar-row md-collapse-lateral">
      <div class="md-toolbar-section-start">
        <h5
          class="md-title regular"
          style="cursor:pointer; font-size:14px !important"
          @click="$router.push({name:'main'})"
        >
          <img :src="conference.description[language.code].logoBrightImg" class="conference-icon" />
          <span class="conf-name">{{$t('My Forum')}}</span>
        </h5>
      </div>
      <div class="md-toolbar-section-end" style="flex:0 0;">
        <md-button
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{ toggled: toggledClass }"
          @click="toggleNavbarMobile()"
        >
          <span class="icon-bar" />
          <span class="icon-bar" />
          <span class="icon-bar" />
        </md-button>

        <div class="md-collapse">
          <div class="md-collapse-wrapper">
            <md-list>
              <li class="md-list-item" style="margin-right:10px">
                <div class="md-list-item-content">
                  <drop-down direction="down">
                    <md-button
                      @click="changeLanguage(otherLang)"
                      class="md-button md-button-link md-white md-round md-sm"
                    >
                      <span style="text-decoration:underline; font-weight:400">{{language.locale}}</span>
                      <span style="opacity:0.75;margin-left:4px">/ {{otherLang.locale}}</span>
                    </md-button>
                  </drop-down>
                </div>
              </li>

              <li class="md-list-item" style="margin-right:10px">
                <div class="md-list-item-content">
                  <drop-down direction="down">
                    <md-button
                      slot="title"
                      class="md-button md-button-link md-white dropdown-toggle md-round md-sm"
                      data-toggle="dropdown"
                    >{{$t('Conference')}}</md-button>
                    <ul class="dropdown-menu dropdown-with-icons">
                      <li>
                        <router-link :to="{ name: 'information' }">
                          <i class="material-icons">info</i>
                          {{$t('Organizational Information')}}
                        </router-link>
                      </li>

                      <li v-if="hasAttendeesAccess">
                        <router-link :to="{ name: 'attendees' }">
                          <i class="material-icons">people</i>
                          {{$t('List of participants')}}
                        </router-link>
                      </li>
                      <li v-if="hasAgendaAccess">
                        <router-link :to="{ name: 'panels' }">
                          <i class="material-icons">calendar_today</i>
                          {{$t('Programme')}}
                        </router-link>
                      </li>

                      <li>
                        <router-link :to="{ name: 'cultural-events' }">
                          <i class="material-icons">museum</i>
                          {{$t('Cultural events')}}
                        </router-link>
                      </li>
                      <li v-if="hasPartyAccess">
                        <router-link :to="{ name: 'party-events' }">
                          <i class="material-icons">golf_course</i>
                          {{$t('Recreational events')}}
                        </router-link>
                      </li>

                      <li>
                        <router-link :to="{ name: 'map' }">
                          <i class="material-icons">map</i>
                          {{$t('Map')}}
                        </router-link>
                      </li>
                      <li>
                        <router-link :to="{ name: 'buildings' }">
                          <i class="material-icons">place</i>
                          {{$t('Conference locations')}}
                        </router-link>
                      </li>

                      <li>
                        <router-link :to="{ name: 'partners' }">
                          <i class="material-icons">business_center</i>
                          {{$t('Partners')}}
                        </router-link>
                      </li>
                      <li v-if="isLoggedIn">
                        <router-link :to="{ name: 'invitations' }">
                          <i class="material-icons">email</i>
                          {{$t('Invitations')}}
                        </router-link>
                      </li>
                    </ul>
                  </drop-down>
                </div>
              </li>

              <li class="md-list-item">
                <span
                  v-if="(newMessagesCount + newContactsCount + notificationsCount) > 0"
                  class="notification"
                  style="left:75px;z-index: 1000; width:22px;height:22px;border-radius:24px;font-weight:400;background:#f44336;padding:0px 0px"
                >{{newMessagesCount + newContactsCount + notificationsCount}}</span>

                <div class="md-list-item-content">
                  <drop-down direction="down">
                    <md-button
                      slot="title"
                      class="md-button md-button-link md-white dropdown-toggle md-round md-sm"
                      data-toggle="dropdown"
                    >{{ $t('Profile') }}</md-button>
                    <ul class="dropdown-menu dropdown-with-icons">
                      <li>
                        <router-link :to="{ name: 'main' }">
                          <i class="material-icons">home</i>
                          {{$t('My Forum')}}
                        </router-link>
                      </li>
                      <li v-if="hasChatAccess">
                        <router-link :to="{ name: 'chat' }">
                          <i class="material-icons">mail</i>
                          {{$t('Forum Mail')}}
                          <span
                            v-if="newMessagesCount > 0 || newContactsCount > 0"
                            class="notification"
                          >{{ newMessagesCount + newContactsCount }}</span>
                        </router-link>
                      </li>
                      <li v-if="hasTransportAccess">
                        <router-link :to="{ name: 'transport' }">
                          <i class="material-icons">train</i>
                          {{$t('Transport registration')}}
                        </router-link>
                      </li>

                      <li v-if="isLoggedIn">
                        <router-link :to="{ name: 'notifications' }">
                          <i class="material-icons">notifications</i>
                          {{$t('Notifications')}}
                          <span
                            v-if="notificationsCount > 0"
                            class="notification"
                          >{{notificationsCount}}</span>
                        </router-link>
                      </li>

                      <li>
                        <router-link :to="{ name: 'profile' }">
                          <i class="material-icons">perm_identity</i>
                          {{$t('Settings')}}
                        </router-link>
                      </li>

                      <li>
                        <a v-if="isLoggedIn" href @click.stop="logout">
                          <i class="material-icons">power_settings_new</i>
                          {{$t('Log out')}}
                        </a>

                        <a v-else href @click.stop="logout">
                          <i class="material-icons">power_settings_new</i>
                          {{$t('Log in')}}
                        </a>
                      </li>
                    </ul>
                  </drop-down>
                </div>
              </li>
            </md-list>
          </div>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
let resizeTimeout;
function resizeThrottler(actualResizeHandler) {
  // ignore resize events as long as an actualResizeHandler execution is in the queue
  if (!resizeTimeout) {
    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      actualResizeHandler();

      // The actualResizeHandler will execute at a rate of 15fps
    }, 66);
  }
}

import { mapGetters, mapActions } from "vuex";
// import MobileMenu from "./MobileMenu";
export default {
  components: {
    // MobileMenu
  },
  props: {
    type: {
      type: String,
      default: "white",
      validator(value) {
        return [
          "white",
          "default",
          "primary",
          "danger",
          "success",
          "warning",
          "info",
          "dark"
        ].includes(value);
      }
    },
    colorOnScroll: {
      type: Number,
      default: 0
    },
    navbarTransparent: {
      type: Boolean,
      default: false
    },
    isNavbarFixed: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      extraNavClasses: "",
      toggledClass: false
    };
  },
  computed: {
    ...mapGetters({
      language: "language/current",
      languages: "language/all",
      conference: "conference/current",
      conferences: "conference/all",
      isLoggedIn: "user/isLoggedIn",
      hasAgendaAccess: "user/hasAgendaAccess",
      hasAttendeesAccess: "user/hasAttendeesAccess",
      hasChatAccess: "user/hasChatAccess",
      hasTransportAccess: "user/hasTransportAccess",
      hasPartyAccess: "user/hasPartyAccess",
      notificationsCount: "notifications/count",
      newContactsCount: "hub/newContactsCount",
      newMessagesCount: "hub/newMessagesCount"
    }),
    otherLang() {
      return this.languages.filter(l => l.code != this.language.code)[0];
    }
  },
  async mounted() {
    document.addEventListener("scroll", this.scrollListener);

    var userId = await this.$store.dispatch("user/getUserId");
    await this.$store.dispatch("hub/setSenderId", userId);
    await this.$store.dispatch("hub/openChatConnection");
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.scrollListener);
  },
  methods: {
    ...mapActions({
      changeLanguage: "language/changeCurrent"
    }),
    async logout() {
      this.$store.dispatch("user/logout");
      this.$router.push({ name: "login" });
    },
    async changeConference(conf) {
      await this.$store.dispatch("conference/changeCurrent", conf);
      await this.$store.dispatch("user/refreshProfile");
    },
    bodyClick() {
      let bodyClick = document.getElementById("bodyClick");

      if (bodyClick === null) {
        let body = document.querySelector("body");
        let elem = document.createElement("div");
        elem.setAttribute("id", "bodyClick");
        body.appendChild(elem);

        let bodyClick = document.getElementById("bodyClick");
        bodyClick.addEventListener("click", this.toggleNavbarMobile);
      } else {
        bodyClick.remove();
      }
    },
    toggleNavbarMobile() {
      this.NavbarStore.showNavbar = !this.NavbarStore.showNavbar;
      this.toggledClass = !this.toggledClass;
      this.bodyClick();
    },
    handleScroll() {
      let scrollValue =
        document.body.scrollTop || document.documentElement.scrollTop;
      let navbarColor = document.getElementById("toolbar");
      this.currentScrollValue = scrollValue;
      if (this.colorOnScroll > 0 && scrollValue > this.colorOnScroll) {
        this.extraNavClasses = `md-${this.type}`;
        navbarColor.classList.remove("md-transparent");
      } else {
        if (this.extraNavClasses) {
          this.extraNavClasses = "";
          navbarColor.classList.add("md-transparent");
        }
      }
    },
    scrollListener() {
      resizeThrottler(this.handleScroll);
    }
  },
  watch: {
    newContactsCount: function(value) {
      console.log("new contacts: " + this.newContactsCount);
    },
    newMessagesCount: function(value) {
      console.log("new messages count: " + value);
    }
  }
};
</script>

<style lang="scss" scoped>
.conference-icon {
  height: 50px;
  width: 50px;
  margin-right: 15px;
}
.language-icon {
  width: 25px;
  -webkit-box-shadow: 1px 1px 2px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 1px 1px 2px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 1px 1px 2px 0px rgba(0, 0, 0, 0.75);
}

.md-button.md-white,
.md-button.md-white i,
.md-button.md-white:hover,
.md-button.md-white:hover i,
.md-button.md-white:focus,
.md-button.md-white:focus i,
.md-button.md-white:active,
.md-button.md-white:active i,
.md-button.md-white.active,
.md-button.md-white.active i {
  color: #3678b6 !important;
}
</style>

<style lang="scss">
.md-list-item
  .md-button.md-button-link:not(.md-just-icon):not(.md-btn-fab):not(.md-icon-button):not(.md-toolbar-toggle)
  .md-ripple {
  min-height: 36px !important;
  border-radius: 50px;
}

/* .dropdown-toggle .md-ripple::after,
.dropdown .dropdown-menu .dropdown-toggle::after {
  display: none !important;
} */

.dropdown .md-button {
  box-shadow: none !important;
}

.first-badge {
  right: -8px;
}

.second-badge {
  right: 10px;
}

.one-badge {
  right: 4px;
}
@media (max-width: 480px) {
  #toolbar {
    padding-left: 0px;
    justify-content: start !important;
  }
  .md-toolbar-row {
    padding-left: 10px !important;
  }
  .md-toolbar-section-end {
    position: absolute;
    right: 20px;
  }
  .conf-name {
    display: none;
  }
  .md-white .conf-name {
    display: block;
  }
}
@media (max-width: 380px) {
  .wrapper {
    width: 380px;
  }
}
</style>